var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M17.646 9.354a.5.5 0 0 1 .708-.708l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L19.293 12h-8.787a.5.5 0 1 1 0-1h8.787l-1.647-1.646zM15 16.5a.5.5 0 1 1 1 0v2c0 1.378-1.121 2.5-2.492 2.5H6.492A2.493 2.493 0 0 1 4 18.5v-13C4 4.122 5.121 3 6.492 3h7.016A2.5 2.5 0 0 1 16 5.501V6.5a.5.5 0 0 1-1 0v-.999A1.5 1.5 0 0 0 13.508 4H6.492C5.674 4 5 4.674 5 5.5v13c0 .832.666 1.5 1.492 1.5h7.016c.818 0 1.492-.674 1.492-1.5v-2z" })
  );
});